import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TimeSheetGoalChartFragment } from '../../../__generated__/graphql';
import { useTranslation } from 'react-i18next';
import GoalChart from '../../../components/TimeSheet/GoalChart';
import WeekChart from '../../../components/TimeSheet/WeekChart';

type Props = {
  timeSheet: TimeSheetGoalChartFragment;
};

const ChartsRow: React.FC<React.PropsWithChildren<Props>> = ({ timeSheet }) => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col md={6}>
        <h4 className="text-center mb-4">
          {t('timeTracking.graphs.goal.title')}
        </h4>
        <GoalChart timeSheet={timeSheet} />
      </Col>
      <Col md={6}>
        <h4 className="text-center  mb-4">
          {t('timeTracking.graphs.week.title')}
        </h4>
        <WeekChart
          startDate={timeSheet.flair__Start_Date__c}
          tracked={timeSheet.trackedTime}
        />
      </Col>
    </Row>
  );
};

export default ChartsRow;
